import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';

// Connectivity pill for AWS Parameter Store, mirroring the Odoo sync pill.
// Polls GET /api/admin/ssm/status on mount: configured = AWS creds wired,
// reachable = a live DescribeParameters probe succeeded. No names/values shown.
export default function SsmStatusPill() {
  const [status, setStatus] = useState(null); // { configured, reachable } | null while loading
  const [failed, setFailed] = useState(false);

  const mountedRef = useRef(true);
  useEffect(() => { mountedRef.current = true; return () => { mountedRef.current = false; }; }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/admin/ssm/status`, { withCredentials: true });
        if (mountedRef.current) setStatus(res.data);
      } catch {
        if (mountedRef.current) setFailed(true);
      }
    })();
  }, []);

  let tone = 'bad';
  let label = 'Parameter Store: checking…';
  if (failed) {
    label = 'Parameter Store: status unavailable';
  } else if (status) {
    if (!status.configured) {
      tone = 'muted';
      label = 'Parameter Store: not configured';
    } else if (status.reachable) {
      tone = 'ok';
      label = 'Parameter Store: connected';
    } else {
      tone = 'bad';
      label = 'Parameter Store: unreachable';
    }
  }

  return (
    <span className={`apps-status-pill apps-status-pill--${status || failed ? tone : 'loading'}`} role="status">
      {label}
    </span>
  );
}
